import React from "react"
import Button from "../../../components/button/button"
import { StaticImage } from "gatsby-plugin-image"
import Heading from "../../../components/text/heading/heading"
import BodyText from "../../../components/text/body-text/body-text"
import { BsArrowRightSquareFill } from "react-icons/bs";


export const SkillInstituteCards = () => {
  const InstituteStats = [
    {
      key: "1",
      image: (
        <StaticImage
          src="../../../images/index/skillInstitute/skill-1.png"
          alt="A lady Trainer giving training in the class "
        />
      ),
      title: "1000+",
      description: "Certified Trainers",
      color: "#15bf5e",
      bgColor: "#D1FFDE",
    },
    {
      key: "2",
      image: (
        <StaticImage
          src="../../../images/index/skillInstitute/skill-2.png"
          alt="A  trainer giving training to students in lab"
        />
      ),
      title: "180+",
      description: "Simulated Labs",
      color: "#4559ED",
      bgColor: "#E6E2FE",
    },
    {
      key: "3",
      image: (
        <StaticImage
          src="../../../images/index/skillInstitute/skill-3.png"
          alt="A chef showing her skills to students"
        />
      ),
      title: "150k+",
      description: "Training Capacity",
      color: "#c7bd00",
      bgColor: "#FAF7BF",
    },
  ]

  return (
    <>
      <div className="mx-4 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-4">
        {InstituteStats.map(item => (
          <div key={item.key} style={{backgroundColor:item.bgColor}} className={` flex gap-4`}>
            <div className="w-2/5">{item.image}</div>
            <div className="w-3/5 flex flex-col justify-center gap-2">
              <Heading variant="h5" className="text-left">
                {item.title}
              </Heading>
              <BodyText
                variant="bodyText6"
                className="text-left font-normal"
              >
                {item.description}
              </BodyText>
              <BsArrowRightSquareFill color={item.color} size='24px' />
            </div>
          </div>
        ))}
      </div>
    </>
  )
}
